export const CHART_SERIES_DEFAULT_COLORS = ['var(--border-brand)', 'var(--border-primary)'];
export const CHART_LEGEND_DEFAULT_COLORS = ['var(--icon-brand)', 'var(--icon-secondary)'];
